<template>
    <div>
        <van-popup v-model="visible" round position="bottom" closeable @close="resetForm">
            <van-form ref="form" :key="formKey" @submit="onSubmit">
                <h4>代祷信息</h4>
                <van-field v-model="form.intercessor" name="代祷人" placeholder="代祷人" :rules="intercessorRules" />
                <van-field v-model="form.content" name="代祷事项" placeholder="代祷事项" :rules="contentRules" />
                <van-field v-model="form.belongs_church" name="所属堂点" placeholder="所属堂点" />
                <van-field v-model="form.contact_details" name="联系方式" placeholder="联系方式" />
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { getChannelInfo } from '@/api/church'
import { storeIntercession } from '@/api/common'

export default {
    name: 'IntercessionPopup',
    props: {
        showPopup: {
            required: true,
            type: Boolean
        }
    },
    computed: {
        visible: {
            get() {
                return this.showPopup
            },
            set(val) {
                this.$emit('update:showPopup', val)
            }
        }
    },
    data() {
        return {
            form: {
                intercessor: '',
                content: '',
                belongs_church: '',
                contact_details: '',
                channel_id: 0
            },
            channelId: 0,
            intercessorRules: [
                { required: true, message: '请输入代祷人', trigger: 'onBlur' },
                { pattern: /\s*\S+?/, message: '请输入非空字符', trigger: 'onBlur' }
            ],
            contentRules: [
                { required: true, message: '请输入代祷事项', trigger: 'onBlur' },
                { pattern: /\s*\S+?/, message: '请输入非空字符', trigger: 'onBlur' }
            ],
            formKey: 0
        }
    },
    created() {
        getChannelInfo().then(res => {
            this.form.channel_id = res.data.id
            this.channelId = res.data.id
        })
    },
    methods: {
        onSubmit() {
            this.$refs.form.validate().then(() => {
                storeIntercession(this.form).then(() => {
                    Toast.success('等待审核')
                }).catch(() => {
                    Toast.fail('提交失败')
                })
                this.resetForm()
            })
        },
        resetForm() {
            this.$emit('update:showPopup', false)
            this.formKey++ // 清除 form 表单校验
            this.$refs.form.resetValidation()
            this.form = {
                intercessor: '',
                content: '',
                belongs_church: '',
                contact_details: '',
                channel_id: this.channelId
            }
        }
    },
}
</script>

<style lang="less" scoped>
.van-popup {
    .van-form {
        padding: 0 20px;
    }

    .van-field {
        background-color: #EEEEEE;
        border-radius: 10px;
        margin-bottom: 10px;
        padding: 5px 10px;

        input {
            white-space: break-word;
        }

        &:nth-of-type(2) {
            height: 80px;
        }
    }
}
</style>